import { create } from 'zustand'

type ScheduleDemoStore = {
  isSchedulingDemo: boolean
  setIsSchedulingDemo: (isSchedulingDemo: boolean) => void
}

const useScheduleDemoStore = create<ScheduleDemoStore>((set) => ({
  isSchedulingDemo: false,
  setIsSchedulingDemo: (isSchedulingDemo) => set({ isSchedulingDemo }),
}))

export default useScheduleDemoStore
